import { CostCenterTypeBase } from './base/cost-center-type-base';

export class CostCenterType extends CostCenterTypeBase { }